import { FooterDocument, NavigationDocument, PageDocument, SpeakerDocument } from '../types/types.generated'
import { createClient } from '@prismicio/client'
import { repo_name } from '../../config.json'

export async function getData(ref?: string): Promise<{
  pages: PageDocument[]
  speakers: SpeakerDocument[]
  navigation: NavigationDocument
  footer: FooterDocument
}> {
  const client = createClient(repo_name, { ref })

  const [pages, speakers, navigation, footer] = await Promise.all([
    client.getAllByType('page'),
    client.getAllByType('speaker'),
    client.getSingle('navigation'),
    client.getSingle('footer'),
  ])
  return {
    pages,
    speakers,
    navigation,
    footer,
  }
}
